import { useState } from 'react';
import SnakeBarComponent from './snakeBar';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const [isGood, setIsGood] = useState(true);
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // دالة مساعدة لتشفير البيانات بتنسيق URL-encoded (مطلوب لـ Netlify)
  const encode = (data) => {
    return Object.keys(data)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  };

  const handleSubmit = async (e) => {
      e.preventDefault();

      if (!formData.name || !formData.email || !formData.phone || !formData.subject || !formData.message) {
        alert('جميع الحقول مطلوبة!');
        return;
      }

      setIsLoading(true);

      try {
        // نرسل الطلب كـ JSON للفانكشن مباشرة
        // const response = await fetch('/api/send', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify(formData), // نبعت الـ object زي ما هو
        // });

        const response = await fetch('/.netlify/functions/send', { // جرب المسار ده مؤقتاً
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(formData),
});

        if (response.ok) {
          setIsGood(true);
          setMessage('تم إرسال رسالتك بنجاح! سيتم التواصل معك قريباً.');
          setOpen(true);
          setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        } else {
          const errorData = await response.json();
          throw new Error(errorData.error || 'حدث خطأ في السيرفر');
        }
      } catch (error) {
        console.error('Error:', error);
        setIsGood(false);
        setMessage('فشل في إرسال الرسالة، حاول مرة أخرى.');
        setOpen(true);
      } finally {
        setIsLoading(false);
      }
    };

  const handleClose = () => {
    setOpen(false);
  };

  return (
     <section id="contactUs" className="mt-5 py-5 container">
       <div className="text-center">
         <span className="spanEffect mt-4">Contact Us</span>
         <h1
           className="text-white mt-2"
           style={{ fontSize: '2.5rem', fontWeight: 600, lineHeight: 2 }}
         >
           Let's Start A New Project
         </h1>
       </div>
       <div className="row mt-5">
         <div className="col-lg-6 mb-4">
           <div className="contact-info text-white">
             <div className="info-item mb-3">
               <i className="fas fa-map-marker-alt" />
               <div>
                 <h3 className="text-effect">Location</h3>
                 <p className="pEffect">Tala , Al-Menofia , Egypt</p>
               </div>
             </div>
             <div className="info-item mb-3">
               <i className="fas fa-phone" />
               <div>
                 <h3 className="text-effect">Phone</h3>
                 <p className="pEffect">+20102534656</p>
               </div>
             </div>
             <div className="info-item mb-3">
               <i className="fas fa-envelope" />
               <div>
                 <h3 className="text-effect">Email</h3>
                 <p className="pEffect">samielkanasoo4@gmail.com</p>
               </div>
             </div>
           </div>
         </div>
        <div className="col-lg-6">
          {/* الإضافات المهمة للفورم: name و data-netlify */}
          <form 
            name="contact" 
            method="POST"
            onSubmit={handleSubmit}
          >
            {/* حقل مخفي مطلوب لـ React في Netlify */}
            <input type="hidden" name="form-name" value="contact" />
            
            <div className="row mb-3">
              <div className="col-md-6 mb-3 mb-md-0">
                <div className="form__group field">
                  <input
                    type="text"
                    className="form__field"
                    placeholder="Your Name"
                    name="name"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name" className="form__label">Name</label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form__group field">
                  <input
                    type="email"
                    className="form__field"
                    placeholder="Example@gmail.com"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="email" className="form__label">Email</label>
                </div>
              </div>
            </div>

            {/* باقي الحقول (Phone, Subject, Message) */}
            <div className="row mb-3">
              <div className="col-md-6 mb-3 mb-md-0">
                <div className="form__group field">
                  <input
                    type="text"
                    className="form__field"
                    placeholder="Your Phone"
                    name="phone"
                    id="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="phone" className="form__label">Phone</label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form__group field">
                  <input
                    type="text"
                    className="form__field"
                    placeholder="Your Subject"
                    name="subject"
                    id="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="subject" className="form__label">Subject</label>
                </div>
              </div>
            </div>

            <div className="form-floating mb-3">
              <textarea
                className="form__field"
                placeholder="Leave a comment here"
                id="floatingTextarea2"
                style={{ height: 100 }}
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              />
              <label htmlFor="floatingTextarea2" className="form__label">Start Writing</label>
            </div>

            <div className="mt-4">
              <button type="submit" className="btn btn-outline-success say-hello" disabled={isLoading}>
                {isLoading ? 'Sending...' : 'Submit Now'}
              </button>
              <SnakeBarComponent isGood={isGood} message={message} open={open} handleClose={handleClose} />
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;